export const useGetNameOrValue = (field: string | { name: string }): string =>
    typeof field === 'object' ? field.name : field;
